import React, { useRef, useState, useEffect } from 'react';
// data 
import { menuData } from '../data';
// motion
import { motion } from 'framer-motion';
// variants
import { fadeIn, staggerContainer } from '../variants';
// react-scroll
import { Link } from 'react-scroll';
//drinks
import MenuWebDesign from './MenuWebDesign';
//lunch special
import MenuReservations from './MenuReservations'
//Japanese menu
import MenuTableData from './MenuTableData'
//Thai menu
import MenuItems from './MenuItems';
//Kids menu
import MenuPricing from './MenuPricing';

const Menu = ({ scrollToFooter }) => {
  const { title, subtitle, modelImg, menuItems, btnText } = menuData;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('drinkMenu');

  const sections = {
    drinkMenu: useRef(null),
    lunchSpecial: useRef(null),
    japaneseMenu: useRef(null),
    thaiMenu: useRef(null),
    kidsMenu: useRef(null),
  };

  // Remove the custom handleScroll and its event listener

  const handleConsultationClick = () => {
    setIsModalOpen(false);
    if (scrollToFooter) scrollToFooter();
  };

  // handle gallery item click to open modal
  const handleGalleryItemClick = (identifier) => {
    setActiveSection(identifier);
    setIsModalOpen(true);
  };
  
  const galleryCount = menuItems.length;
  const gridCols =
  galleryCount === 1
    ? 'lg:grid-cols-1'
    : galleryCount === 2
    ? 'lg:grid-cols-2'
    : galleryCount === 3
    ? 'lg:grid-cols-3'
    : 'lg:grid-cols-4';

  // When the modal opens, scroll to the selected section.
  useEffect(() => {
    if (isModalOpen) {
      const sectionRef = sections[activeSection]?.current;
      if (sectionRef) {
        const modalContent = document.getElementById('modalContent');
        if (modalContent) {
          modalContent.scrollTop = sectionRef.offsetTop - 60;
        }
      }
    }
  }, [isModalOpen, activeSection]);

  return (
    <section className='select-none min-h-[780px]'>
      <div className='h-[780px] bg-menu absolute w-full -z-0'></div>
      <div className='relative z-10 top-32 lg:top-52'>
        <motion.div
          variants={staggerContainer}
          initial='hidden'
          whileInView={'show'}
          viewport={{ once: false, amount: 0.1 }}
          className='container mx-auto flex flex-col items-center text-center'
        >
          <motion.h2 variants={fadeIn('down', 'tween', 0.0, 1.6)} className='h2 capitalize text-white max-w-[400px]'>
            A Menu of More Features
          </motion.h2>
          <motion.p variants={fadeIn('down', 'tween', 0.4, 1.6)} className='text-white/70 mb-4'>
            {subtitle}
          </motion.p>
          <motion.div variants={fadeIn('down', 'tween', 0.6, 1.6)}
          >
            <img src={modelImg} alt='' />
          </motion.div>
        </motion.div>
      </div>
      {/* menu gallery */}
      <motion.div
        initial={{ opacity: 0, y: 150 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ type: 'tween', delay: 0.1, duration: 1.0, ease: 'easeOut' }}
        className='relative top-52 lg:top-64'
      >
        <div className='container mx-auto'>


          <div className="min-h-[340px] z-30 mb-6 md:mb-4 xl:mb-6 ">
            <div
  className={`cursor-pointer grid grid-cols-1 ${gridCols} min-h-[340px] border-2 border-stone-700 overflow-hidden rounded-3xl shadow-[0_2px_30px_rgba(120,113,108,0.95)]`}
>
              {menuItems.map((item, index) => {
                const { image, name, description, identifier } = item;
                return (
                  <div key={index} onClick={() => handleGalleryItemClick(identifier)}>
                    <div className="flex flex-row lg:flex-col lg:h-[340px] xl:h-[340px] hover:drop-shadow-2xl hover:scale-105">
                      {/* image */}
                      <div
                        className={`w-[45%] lg:w-auto lg:h-[60%] overflow-hidden ${
                          index === 1 || index === 3 ? 'lg:order-1' : ''
                        }`}
                      >
                        <img
                          src={image}
                          alt=""
                          className=" w-full h-full object-cover"
                        />
                      </div>
  
                      {/* text */}
                      <div className="flex-1 flex bg-gradient-to-t from-[#a98737] to-[#694f1e] flex-col justify-center px-6">
                        <div className="text-center">
                          <div className="my-1 text-[20px] lg:text-[22px] text-[#eecf88] font-semibold">
                            {name} 
                          </div>
                          <div className="lg:text-[18px] text-[#fff4db]">
                            {description}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>


          <button className='btn capitalize mx-auto shadow-[0_2px_30px_rgba(120,113,108,0.95)]' onClick={() => setIsModalOpen(true)}>
            All Features and Pricing
          </button>
        </div>
      </motion.div>

      {isModalOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
          <div id='modalContent' className='border border-stone-100 bg-white w-full h-full md:w-3/4 md:h-4/5 overflow-y-scroll rounded-xl'>
            <nav className="sticky top-0 w-full bg-emerald-700 shadow-md z-50 rounded-xl">
              <ul className="flex flex-wrap justify-center sm:flex-row sm:items-center">
                <li>
                  <Link
                    to="drinkMenu"
                    containerId="modalContent"
                    smooth={true}
                    duration={500}
                    offset={-50}
                    onSetActive={() => setActiveSection('drinkMenu')}
                    className={`cursor-pointer ${activeSection === 'drinkMenu' ? 'h-10 btn m-1 p-2' : 'h-10 btn m-1 p-2'}`}
                  >
                  Web Design
                  </Link>
                </li>
                <li>
                  <Link
                    to="lunchSpecial"
                    containerId="modalContent"
                    smooth={true}
                    duration={500}
                    offset={-50}
                    onSetActive={() => setActiveSection('lunchSpecial')}
                    className={`cursor-pointer ${activeSection === 'lunchSpecial' ? 'h-10 btn m-1 p-2' : 'h-10 btn m-1 p-2'}`}
                  >
                    Reservations
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="japaneseMenu"
                    containerId="modalContent"
                    smooth={true}
                    duration={500}
                    offset={-50}
                    onSetActive={() => setActiveSection('japaneseMenu')}
                    className={`cursor-pointer ${activeSection === 'japaneseMenu' ? 'h-10 btn m-1 p-2' : 'h-10 btn m-1 p-2'}`}
                  >
                    Table Data
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="thaiMenu"
                    containerId="modalContent"
                    smooth={true}
                    duration={500}
                    offset={-50}
                    onSetActive={() => setActiveSection('thaiMenu')}
                    className={`cursor-pointer ${activeSection === 'thaiMenu' ? 'h-10 btn m-1 p-2' : 'h-10 btn m-1 p-2'}`}
                  >
                    Menu + Item Control
                  </Link>
                </li>
                <li>
                  <Link
                    to="kidsMenu"
                    containerId="modalContent"
                    smooth={true}
                    duration={500}
                    offset={-50}
                    onSetActive={() => setActiveSection('kidsMenu')}
                    className={`cursor-pointer ${activeSection === 'kidsMenu' ? 'h-10 btn m-1 p-2' : 'h-10 btn m-1 p-2'}`}
                  >
                    Pricing + Stripe
                  </Link>
                </li>
                <li>
                  <button
                    className='cursor-pointer text-white text-2xl border w-10 h-10 rounded-full m-1 sm:m-2'
                    onClick={() => setIsModalOpen(false)}
                  >
                    &times;
                  </button>
                </li>
              </ul>
            </nav>
            <div className="mt-8">
              <MenuWebDesign ref={sections.drinkMenu} onConsultationClick={handleConsultationClick} />
              <MenuReservations ref={sections.lunchSpecial} />
              {/* <MenuTableData ref={sections.japaneseMenu} /> */}
              <MenuItems ref={sections.thaiMenu} />
              <MenuPricing ref={sections.kidsMenu} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Menu;
